const hotels = {
  accommodation: "דִיוּר", // translated
  hotel: "מלון", // translated
  hotels: "בתי מלון", // translated
  back: "חזור", // translated
  rooms: "חדרים", // translated
  viewPictures: "צפה בתמונות", // translated
  showMore: "להראות יותר", // translated
  bookingInformation: "מידע על הזמנה", // translated
  importantInformation: "מידע חשוב", // translated
  cancellationPolicy: "מדיניות ביטול", // translated
  from: "מ", // translated
  to: "ל", // translated
  cancellationIs: "ביטול הוא", // translated
  free: "חינם", // translated
  chargeableWithFeeOf: "בתשלום של", // translated
  prebook: "הזמנה מראש", // translated
  guests: "אורחים", // translated
  payment: "תַשְׁלוּם", // translated
  byClicking: "על ידי לחיצה", // translated
  next: "הַבָּא", // translated
  youAreAgreeingToOur: "אתה מסכים שלנו", // translated
  termsAndConditions: "תנאים", // translated
  previous: "קודם", // translated
  cancel: "לְבַטֵל", // translated
  mealPlan: "תוכנית ארוחה", // translated
  roomType: "סוג חדר", // translated
  description: "תיאור", // translated
  readLess: "תקרא פחות", // translated
  readMore: "קרא עוד", // translated
  facilities: "מתקנים", // translated
  viewLess: "הצג פחות", // translated
  viewMore: "ראה עוד", // translated
  less: "פָּחוֹת", // translated
  more: "יותר", // translated
  notAvailable_short: "לא", // translated
  backToHotelList: "חזרה לרשימת המלונות", // translated
  viewOnMap: "צפה במפה", // translated
  sleeps: "ישן", // translated
  adults: "מבוגרים", // translated
  yearsOld: "שנים", // translated
  type: "סוּג", // translated
  bedding: "מצעים", // translated
  selectRoom: "בחר חדר", // translated
  selectRooms: "בחר חדרים", // translated
  city: "עִיר", // translated
  checkIn: "קבלה", // translated
  checkOut: "לבדוק", // translated
  date: "תַאֲרִיך", // translated
  dates: "תאריכים", // translated
  persons: "אנשים", // translated
  stillOnTrialQuestionToUpgrade: "אופס! נראה שאתה עדיין בחברות ניסיון. עליך להיות חבר מאושר כדי לבצע הזמנות. האם תרצה לשדרג עכשיו?", // translated
  stillOnTrialQuestionToUpgradeNonElligib: "אופס! נראה שעדיין לא נרשמת. עליך להיות חבר מאושר כדי לבצע הזמנות. האם תרצה לשדרג עכשיו?", // translated
  completeProfile: "אנא מלא תחילה את פרופיל המשתמש שלך", // translated
  upgrade: "שדרוג", // translated
  close: "סגור", // translated
  viewDetails: "הצג פרטים", // translated
  name: "שֵׁם", // translated
  rating: "דֵרוּג", // translated
  budget: "תַקצִיב", // translated
  orderBy: "מיין לפי", // translated
  priceLowestFirst: "מחיר מהנמוך לגבוה)", // translated
  priceHighestFirst: "המחיר (הגבוה ביותר ראשון)", // translated
  ratingLowestFirst: "דירוג (הנמוך ביותר ראשון)", // translated
  ratingHighestFirst: "דירוג (הכי גבוה ראשון)", // translated
  starRatingAndPrice: "דירוג כוכבים ומחיר", // translated
  biggestSavingsFirst: "החיסכון הגדול ביותר קודם כל", // translated
  select: "בחר", // translated
  reset: "אִתחוּל", // translated
  apply: "להגיש מועמדות", // translated
  filterBy: "סנן לפי", // translated
  myProfile: "הפרופיל שלי", // translated
  login: "התחברות", // translated
  roomOnly: "חדר בלבד", // translated
  bedAndBreakfast: "שינה וארוחת בוקר", // translated
  halfBoard: "חצי פנסיון", // translated
  fullBoard: "פנסיון מלא", // translated
  allInclusive: "הכל כלול", // translated
  filter: "לְסַנֵן", // translated
  mapView: "תצוגת מפה", // translated
  results: "תוצאות", // translated
  listView: "תצוגת רשימה", // translated
  newSearch: "חיפוש חדש", // translated
  editSearch: "ערוך חיפוש", // translated
  all: "את כל", // translated
  multiple: "מרובות", // translated
  editProfile: "ערוך פרופיל", // translated
  backToHotelsList: "חזרה לרשימת המלונות", // translated
  roomName: "שם חדר", // translated
  mealType: "סוג ארוחה", // translated
  freeCancellation: "ביטול חופשי", // translated
  yes: "כן", // translated
  no: "לא", // translated
  filters: "מסננים", // translated
  cancellationNonRefundable: "ביטול אינו ניתן להחזר", // translated
  hotelRating: "דירוג מלון", // translated
  any: "כל", // translated
  off: "כבוי", // translated
  performNewSearch: "בצע חיפוש חדש", // translated
};


export default hotels;
